module.exports = __webpack_public_path__ + "static/media/vaibhav.1a89f0b6.jpg";